import { useTranslation } from "react-i18next";
import { useDisplayDate } from "../../../../../../common/formatting/useDisplayDate";
import { refusedFieldErrors, refusedRemovalFieldErrors } from "../../../../../../common/redux/reducers/contractReducer";
import { useExtensionName } from "../../../../options/extensionName";
import { useContractState } from "../../../useContractState";
import { EXTENSIONS_OVERLAP, useExtensionsOverlapExplanation } from "./useExtensionsOverlapExplanation";

const BEFORE_EXERCISED_EXTENSION = "zz_ContractApiErrorCode_EndDateBeforeExercisedExtension";
const PAST_NEXT_EXTENSION = "zz_ContractApiErrorCode_EndDatePastNextExtension";

export const useEndDateOutsideExtensionsRefusal = (): string | null => {
  const { t } = useTranslation();
  const displayDate = useDisplayDate();
  const contractState = useContractState();
  const nameOf = useExtensionName(contractState.contract.dataFields.options ?? []);
  const explainOverlap = useExtensionsOverlapExplanation();
  const refusals = [
    ...refusedFieldErrors(contractState, "EditExpirationDate"),
    ...refusedRemovalFieldErrors(contractState, "endDate"),
  ];
  const explanations = refusals.flatMap((refusal) => {
    if (refusal.code === EXTENSIONS_OVERLAP) return [explainOverlap(refusal)];
    const name = nameOf({ id: refusal.params?.optionId, name: refusal.params?.name });
    if (refusal.code === BEFORE_EXERCISED_EXTENSION) {
      return [
        t("{{name}} is exercised until {{end}}, so the contract cannot end before that.", {
          name,
          end: displayDate(refusal.params?.extensionEnd ?? ""),
        }),
      ];
    }
    if (refusal.code === PAST_NEXT_EXTENSION) {
      return [
        t("{{name}} starts on {{start}}, so the contract must end before that.", {
          name,
          start: displayDate(refusal.params?.extensionStart ?? ""),
        }),
      ];
    }
    return [];
  });
  return explanations.length === 0 ? null : explanations.join(" ");
};
